const isTest = !!(import.meta as any).vitest;

const environmentVariables = {
    BASE_URL: import.meta.env.VITE_BASE_URL,
    VITE_API_URL: import.meta.env.VITE_API_URL,
    VITE_APP_URL: import.meta.env.VITE_APP_URL,
    VITE_APP_ECHO_SERVICE_HOST: isTest ? null : import.meta.env.VITE_APP_ECHO_SERVICE_HOST,
    VITE_APP_ECHO_SERVICE_PORT: isTest ? null : import.meta.env.VITE_APP_ECHO_SERVICE_PORT,
    VITE_APP_ECHO_SERVICE_APP_KEY: import.meta.env.VITE_APP_ECHO_SERVICE_APP_KEY,
    VITE_SEAT_ALLOCATOR_ENABLE_GRID: import.meta.env.VITE_APP_SEAT_ALLOCATOR_ENABLE_GRID,
    VITE_SEAT_ALLOCATOR_ENABLE_AXIS_LINES: import.meta.env
        .VITE_APP_SEAT_ALLOCATOR_ENABLE_AXIS_LINES,
    VITE_DEPLOYED_ENV: import.meta.env.VITE_DEPLOYED_ENV,
    VITE_ROLLBAR_CLIENT_TOKEN: import.meta.env.VITE_ROLLBAR_CLIENT_TOKEN,
    VITE_ROLLBAR_ENV: import.meta.env.VITE_ROLLBAR_ENV,
    VITE_ROLLBAR_ENABLED: import.meta.env.VITE_ROLLBAR_ENABLED,
    VITE_APP_VERSION_ID: import.meta.env.VITE_APP_VERSION_ID,
    VITE_APP_INSIGHTS_KEY: import.meta.env.VITE_APP_INSIGHTS_KEY,
    VITE_APP_ASSETS_STORAGE_URL: import.meta.env.VITE_APP_ASSETS_STORAGE_URL,
    VITE_APP_OAUTH_CLIENT_ID: import.meta.env.VITE_APP_OAUTH_CLIENT_ID,
    VITE_APP_ECHO_SERVICE_PATH: import.meta.env.VITE_APP_ECHO_SERVICE_PATH,
    VITE_SPLUNK_DEPLOYED_ENV: import.meta.env.VITE_SPLUNK_DEPLOYED_ENV,
    VITE_SPLUNK_REALM: import.meta.env.VITE_SPLUNK_REALM,
    VITE_SPLUNK_RUM_TOKEN: import.meta.env.VITE_SPLUNK_RUM_TOKEN,
    VITE_SPLUNK_APP_NAME: import.meta.env.VITE_SPLUNK_APP_NAME,
    VITE_SPLUNK_BEACON_ENDPOINT: import.meta.env.VITE_SPLUNK_BEACON_ENDPOINT,
    VITE_APP_OAUTH_TOKEN_ENDPOINT: import.meta.env.VITE_APP_OAUTH_TOKEN_ENDPOINT,
    VITE_APP_AUTH_RENEW_MODAL_TIME_IN_SECONDS_BEFORE_EXPIRATION: import.meta.env
        .VITE_APP_AUTH_RENEW_MODAL_TIME_IN_SECONDS_BEFORE_EXPIRATION,
};

const getEnvVariable = (envKey: keyof typeof environmentVariables, runtimeKey?: string | null) =>
    (window as any).APP_RUNTIME_ENVIRONMENT?.[runtimeKey ?? envKey] ?? environmentVariables[envKey];

export const PUBLIC_PATH = (getEnvVariable('BASE_URL') ?? '').replace(/\/$/, '');

export const API_URL = getEnvVariable('VITE_API_URL');
export const APP_URL = getEnvVariable('VITE_APP_URL');
export const OAUTH_TOKEN_ENDPOINT =
    getEnvVariable('VITE_APP_OAUTH_TOKEN_ENDPOINT') ?? 'api/v1/oauth/token';

export const ECHO_SERVICE_HOST = getEnvVariable('VITE_APP_ECHO_SERVICE_HOST');
export const ECHO_SERVICE_PORT = getEnvVariable('VITE_APP_ECHO_SERVICE_PORT');
export const ECHO_SERVICE_PATH = getEnvVariable('VITE_APP_ECHO_SERVICE_PATH');

export const AUTH_RENEW_MODAL_TIME_IN_SECONDS_BEFORE_EXPIRATION =
    getEnvVariable('VITE_APP_AUTH_RENEW_MODAL_TIME_IN_SECONDS_BEFORE_EXPIRATION') ?? 120;

export const ECHO_SERVICE_APP_KEY =
    getEnvVariable('VITE_APP_ECHO_SERVICE_APP_KEY') ?? 'fifa-backoffice';
export const SEAT_ALLOCATOR_ENABLE_GRID =
    getEnvVariable('VITE_SEAT_ALLOCATOR_ENABLE_GRID') === 'true';
export const SEAT_ALLOCATOR_ENABLE_AXIS_LINES =
    getEnvVariable('VITE_SEAT_ALLOCATOR_ENABLE_AXIS_LINES') === 'true';
export const APP_INSIGHTS_KEY = getEnvVariable('VITE_APP_INSIGHTS_KEY');

export const E_TICKETS_DISTRIBUTION_DEFAULT_BCC_EMAIL = 'etickets@fifa.org';

export const ROLLBAR_CLIENT_TOKEN = getEnvVariable('VITE_ROLLBAR_CLIENT_TOKEN');
export const ROLLBAR_ENV = getEnvVariable('VITE_ROLLBAR_ENV');
export const ROLLBAR_ENABLED = getEnvVariable('VITE_ROLLBAR_ENABLED') === 'true';
export const DEPLOYED_ENV = getEnvVariable('VITE_DEPLOYED_ENV');

export const APP_VERSION_ID = getEnvVariable('VITE_APP_VERSION_ID');

export const STORAGE_URL = getEnvVariable('VITE_APP_ASSETS_STORAGE_URL');
export const FLAGS_PATH = 'assets/flags';

export const OAUTH_CLIENT_ID = getEnvVariable('VITE_APP_OAUTH_CLIENT_ID');

export const SPLUNK_REALM = getEnvVariable('VITE_SPLUNK_REALM');
export const SPLUNK_TOKEN = getEnvVariable('VITE_SPLUNK_RUM_TOKEN');
export const SPLUNK_APP_NAME = getEnvVariable('VITE_SPLUNK_APP_NAME');
export const SPLUNK_ENV = getEnvVariable('VITE_SPLUNK_DEPLOYED_ENV');
export const SPLUNK_BEACON = getEnvVariable('VITE_SPLUNK_BEACON_ENDPOINT');

export default { API_URL, APP_URL };
